import { APIModel, APIModelImpl, APIModelHandler } from '../../../toolkit/uicomponentapimodel';
import { BaseContext } from '../../../../utils/basecontext';
import { ListTonesDtoImpl } from '../../../../core/dto/listtones/listtonesdto';
import { ListTonesResponse } from '../../../../core/api/mytunes/listtones/listtonesresponse';
import { ListTonesRequestImpl } from '../../../../core/api/mytunes/listtones/listtonesrequest';
import { GetKaroakeListDtoImpl } from '../../../../core/dto/getkaroakelist/getkaroakelistdto';
import { GetKaroakeListResponse } from '../../../../core/api/karoake/getkaroakelist/getkaroakelistresponse';
import { GetKaroakeListRequestImpl } from '../../../../core/api/karoake/getkaroakelist/getkaroakelistrequest';
import { SearchToneDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/searchtone/searchtonedto';
import { SearchToneResponse } from 'src/com/sixdee/crbtportal/core/api/search/searchtone/searchtoneresponse';
import { SearchToneRequestImpl } from 'src/com/sixdee/crbtportal/core/api/search/searchtone/searchtonerequest';
import { ToneDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/tonedto';

export interface TunesAPIModel extends APIModel
{
    getTunes(): void;
    getPlaylist(): void;
    getProfileTunes(): void;
}

export class TunesAPIModelImpl extends APIModelImpl implements TunesAPIModel
{
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);
    }

    getDoItYourself(): void {
        let getKaroakeListDto = new GetKaroakeListDtoImpl();
        getKaroakeListDto.setLanguage(this.getContext().getUserContext().getLanguage());
        getKaroakeListDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        getKaroakeListDto.setChannelId(this.getContext().getUserContext().getChannelId());
        getKaroakeListDto.setServiceId("4");

        this.getAPIProcesssorFactory().getKaroakeProcessorFactory()
        .getKaroakeListDetails()
        .success((getKaroakeListResponse: GetKaroakeListResponse)=>
        {   
            this.getAPIModelHandler().onSuccess(getKaroakeListResponse.getAPIFeature(), 
            getKaroakeListResponse.getDescription(), getKaroakeListResponse.getKaroakeListDto().getListOfTones());
         })
        .failure((getKaroakeListResponse: GetKaroakeListResponse)=>
         {
           this.getAPIModelHandler().onFailure(getKaroakeListResponse.getAPIFeature(), 
           getKaroakeListResponse.getDescription(), undefined);
         })
        .execute(new GetKaroakeListRequestImpl(getKaroakeListDto));
    }

    getProfileTunes(): void {
        let searchToneDto = new SearchToneDtoImpl();
        searchToneDto.setPagePerCount(1);
        searchToneDto.setLanguage(this.getContext().getUserContext().getLanguage());
        //searchToneDto.setSearchKey("Recently+Added"); 
        searchToneDto.setArtistKey("");
        searchToneDto.setSearchKey(""); 
        searchToneDto.setCategoryId(+this.getContext().getConfigurationSettings().getPropertyBasedOnLanguage("STATUSRBT"));
        searchToneDto.setSortBy("Order_By");
        searchToneDto.setAlignBy("ASC");
        searchToneDto.setPageNo(20);
        searchToneDto.setSearchLanguage(this.getContext().getUserContext().getLanguage());

        this.getAPIProcesssorFactory().getSearchToneProcessorFactory()
        .getSearchTone()
        .success((searchToneResponse: SearchToneResponse)=>
        {
            let listOfTones = searchToneResponse.getListOfSearchToneDtos().getListOfTones().map((toneDto: ToneDtoImpl) =>
            {
                toneDto.setArtistName("");
                return toneDto;
            });
            this.getAPIModelHandler().onSuccess(searchToneResponse.getAPIFeature(), 
            searchToneResponse.getDescription(), listOfTones);

         })
        .failure((searchToneResponse : SearchToneResponse)=>
         {
           this.getAPIModelHandler().onFailure(searchToneResponse.getAPIFeature(), 
           searchToneResponse.getDescription(), undefined);
         })
        .execute(new SearchToneRequestImpl(searchToneDto));
    }

    getTunes(): void
    {
        //400 tunes
        //300 playlist
        let listTonesDto = new ListTonesDtoImpl();
        listTonesDto.setLanguage(this.getContext().getUserContext().getLanguage());
        listTonesDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
        listTonesDto.setStartIndex("0");
        listTonesDto.setEndIndex("20");
        listTonesDto.setRbtMode("400");

        this.getAPIProcesssorFactory().getMyTunesProcessorFactory()
        .getListTonesForTunesAPIProcessor()
        .success((listTonesResponse: ListTonesResponse)=>
        {
            console.log("success() invoked ##########LIST TONES###############");
      
            this.getAPIModelHandler().onSuccess(listTonesResponse.getAPIFeature(), 
            listTonesResponse.getDescription(), listTonesResponse.getListTonesResponseDtos());
         })
        .failure((listTonesResponse : ListTonesResponse)=>
         {
           this.getAPIModelHandler().onFailure(listTonesResponse.getAPIFeature(), 
           listTonesResponse.getDescription(), undefined);
         })
        .execute(new ListTonesRequestImpl(listTonesDto));
    }

    getPlaylist(): void 
    {
        let listTonesDto = new ListTonesDtoImpl();
        listTonesDto.setLanguage(this.getContext().getUserContext().getLanguage());
        listTonesDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
        listTonesDto.setStartIndex("0");
        listTonesDto.setEndIndex("20");
        listTonesDto.setRbtMode("300");

        this.getAPIProcesssorFactory().getMyTunesProcessorFactory()
        .getListTonesForPlaylistAPIProcessor()
        .success((listTonesResponse: ListTonesResponse)=>
        {
            console.log("success() invoked ##########LIST TONES###############");

            this.getAPIModelHandler().onSuccess(listTonesResponse.getAPIFeature(), 
            listTonesResponse.getDescription(), listTonesResponse.getListTonesResponseDtos());
         })
        .failure((listTonesResponse : ListTonesResponse)=>
         {
           this.getAPIModelHandler().onFailure(listTonesResponse.getAPIFeature(), 
           listTonesResponse.getDescription(), undefined);
         })
        .execute(new ListTonesRequestImpl(listTonesDto));
    }
   
    getListOfTones()
    {  let tone1 = new ListTonesDtoImpl();
        tone1.setId("6000040204");
        tone1.setToneName("1234rsva");
        tone1.setIsStatusRBT(false);
        tone1.setArtistName("987ytrfgbnmk");
        tone1.setImgPath("http://placehold.it/120x120&text=image1");
        tone1.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_700KB.mp3");


        return [tone1];
    }
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/tunes/tunesapimodel.ts